import React, { forwardRef } from 'react';

import MUIRadioGroup, {
  RadioGroupProps as MUIRadioGroupProps,
} from '@material-ui/core/RadioGroup';

interface RadioGroupProps extends MUIRadioGroupProps {}

const RadioGroup = forwardRef<HTMLDivElement, RadioGroupProps>((props, ref) => {
  return <MUIRadioGroup {...props} ref={ref} />;
});

RadioGroup.displayName = 'RadioGroup';

export default RadioGroup;
